import React from 'react';
import PropTypes from 'prop-types';
import { Form, ModalFooter, ModalBody, Button } from 'reactstrap';
import { withFormik, Field } from 'formik';
import * as Yup from 'yup';

import { renderField } from 'core/utils/formik';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const QaReportForm = ({ handleSubmit, isSubmitting, isValid, onCancel }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <ModalBody>
        <Field
          type="date"
          dateFormat="m/d/Y"
          name="start_date"
          label="Start Date"
          component={renderField}
        />

        <Field
          type="date"
          dateFormat="m/d/Y"
          name="end_date"
          label="End Date"
          component={renderField}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          color="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>{' '}
        <Button
          type="submit"
          color="primary"
          disabled={!isValid || isSubmitting}
        >
          Generate
        </Button>
      </ModalFooter>
    </Form>
  );
};

QaReportForm.propTypes = propTypes;

export default withFormik({
  validationSchema: Yup.object().shape({
    start_date: Yup.string().required('Required'),
    end_date: Yup.string().required('Required'),
  }),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
})(QaReportForm);



// WEBPACK FOOTER //
// ./src/features/qa/QaReportModal/QaReportForm.js